import React from "react";
import LegalPage from "@/components/LegalPage";
import { TERMS_INTRO, TERMS_SECTIONS } from "@/content/legal";

export default function Terms() {
  return <LegalPage title="Terms & Conditions" intro={TERMS_INTRO} sections={TERMS_SECTIONS} />;
}
